module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Breaker.js"));
	}, "Breaker");
}